import { useState } from 'react'

import { Table } from '../../../../Table'
import { TablePagination } from '../../../../TablePagination'
import {
  IMPORT_LOG_SKELETON_ROWS,
  IMPORT_RUN_COLUMNS_CONFIG,
  QA_NAME_INTEGRATIONS_IMPORT_LOG,
} from '../IntegrationsImportLog.constants'
import { getImportRunActions } from '../IntegrationsImportLog.utils'
import { IntegrationsImportLogRow } from '../IntegrationsImportLogRow'

function IntegrationsImportLogRuns({
  containerRef,
  isInitiated,
  isLoading,
  items,
  pagination,
  onCallAction,
  onClickRun,
  onMouseDownRun,
  onSetPagination,
}) {
  const [columns, setColumns] = useState(IMPORT_RUN_COLUMNS_CONFIG)

  return (
    <>
      <Table
        TableRow={IntegrationsImportLogRow}
        actionsColumnWidth={0}
        columns={columns}
        containerRef={containerRef}
        context={QA_NAME_INTEGRATIONS_IMPORT_LOG}
        headerRowProps={{ onSetColumns: setColumns }}
        isLoading={isLoading}
        items={items}
        rowProps={{
          getActions: getImportRunActions,
          onCallAction,
          onClick: onClickRun,
          onMouseDown: onMouseDownRun,
        }}
        skeletonProps={{ withCheckbox: false }}
        skeletonRows={IMPORT_LOG_SKELETON_ROWS}
      />
      <TablePagination
        responsive
        containerRef={containerRef}
        isSkeleton={!isInitiated}
        value={pagination}
        onChange={onSetPagination}
      />
    </>
  )
}

export default IntegrationsImportLogRuns
